export default {
  REMOVE_TEMPLATE_ID: 'remove_template_id',
  REMOVE_SCENE_ID: 'remove_scene_id',
  REMOVE_BACKGROUND: 'remove_background',
  REMOVE_DOCUMENT_AUDIO_TRACK: 'remove_document_audio_track',
  REMOVE_SLIDE_AUDIO_TRACK: 'remove_slide_audio_track',
  REMOVE_SPRITE: 'remove_sprite',
  REMOVE_SPRITE_CONTENT: 'remove_sprite_content',
  REMOVE_LICENSE_SOURCE: 'remove_license_source',
  REMOVE_DUPLICATE_IDS: 'remove_duplicate_ids',
  ADJUST_ASSET_TYPE: 'adjust_asset_type',
  ADJUST_ITEM_TYPE: 'adjust_item_type',
  ADJUST_TRACK_ENDTIME: 'adjust_track_endtime',
  ADJUST_TRACK_STARTTIME: 'adjust_track_starttime',
  ADJUST_AUDIO_TRACK_PLAYBACK_SETTINGS_TIME: 'adjust_audio_track_playback_settings_time',
  ADJUST_VIDEO_TRACK_SETTINGS_TIME: 'adjust_video_track_settings_time',
  ADJUST_TRACK_ANIMATION_GRAPHS: 'adjust_track_animation_graphs',
  REMOVE_INVALID_SLIDE: 'remove_invalid_slide',
  REMOVE_INVALID_TRACK: 'remove_invalid_track',
  REMOVE_INVALID_AUDIO_TRACK: 'remove_invalid_audio_track',
  REMOVE_INVALID_HAND_EFFECT: 'remove_invalid_hand_effect',
  BLANK_INVALID_SLIDE: 'blank_invalid_slide',
  BLANK_NO_SLIDES: 'blank_no_slides',
  ADJUST_FONT_REFERENCES: 'adjust_font_references',
  UPDATE_FONT_NAME: 'update_font_name',
  ADJUST_SLIDE_VIDEO_BACKGROUND_TIME: 'adjust_slide_video_background_time',
  REMOVE_INVALID_TRACK_LINK: 'remove_invalid_track_link',
  ADJUST_SPRITE_SIZE: 'adjust_sprite_size_to_positive_value',
  ADJUST_SPRITE_TEXT: 'adjust_sprite_text_content_to_string',
  MISSING_EXPORT_ASPECT_RATIO: 'missing_export_aspect_ratio',
  ADJUST_CAMERA_SIZE: 'adjust_camera_size_or_position',
  ADJUST_CAMERA_TIME: 'adjust_camera_time',
  REMOVE_EXTRA_TEXT_SPRITE_PROPS: 'remove_extra_text_sprite_props',
  REMOVE_EXTRA_TRACK_PROPS: 'remove_extra_track_props'
}
